"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseExtension = function () {
    function BaseExtension() {
        (0, _classCallCheck3.default)(this, BaseExtension);
    }

    (0, _createClass3.default)(BaseExtension, [{
        key: "bootstrap",


        /**
         *  Register event handlers with Gun, etc.
         * 
         * @returns {void}
         */
        value: function bootstrap() {
            throw "Extensions must implement the `bootstrap` method.";
        }
    }]);
    return BaseExtension;
}();

exports.default = BaseExtension;